module.exports = __webpack_public_path__ + "static/images/jifen_bg@2x.png";